import { module } from 'modujs';
import modularLoad from 'modularload';
import shared from '../shared';

export default class extends module {
    constructor(m) {
        super(m);
    }

    init() {
        const load = new modularLoad({
            enterDelay: 1500,
            transitions: {
                customTransition: {}
            }
        });

        load.on('loading', (oldContainer, newContainer) => {
            this.call('stop', 'Scroll');
        });

        load.on('loaded', (transition, oldContainer, newContainer) => {
            shared();

            this.call('destroy', oldContainer, 'app');
            this.call('update', newContainer, 'app');
        });
        
    }
}
